<template>
  <div id="main_div" :class="theme">
    <header class="app-banner">
      <h1>Dew point calculator</h1>
    </header>
    <div id="form_and_chart">
      <div id="form_div" class="center borderStyle">
        <form>
          <div class="temperature">
            <label for="name">Temperature °C</label>
            <input @input="updateChartandDewPoint" type="number" id="name" v-model="temperature" min="-20" max="100"
              autofocus />
          </div>
          <div class="humidity">
            <label for="profileSummary">Relative humidity %</label>
            <input @input="updateChartandDewPoint" type="number" id="profileSummary" v-model="humidity" min="1"
              max="100" />
          </div>
          <div class="humidity">
            <label for="profileSummary">Dew point °C</label>
            <input type="text" id="profileSummary" :value=dew_point readonly />
          </div>
          <div class="humidity">
            <label for="profileSummary">Absolute humidity g/m3</label>
            <input type="text" id="profileSummary" :value=absolute_humidity readonly />
          </div>
          <div class="humidity">
            <label for="showWeather">Show Warsaw weather</label>
            <input type="checkbox" id="showWeather" v-model="showWeather" class="weather-checkbox" />
          </div>
        </form>
        
        <div class="humidity">
          <WeatherCard @click="reset_temp_to_site" v-if="showWeather" location="Warsaw" :temperature="site_temperature"
            :humidity="site_humidity" :wind="site_wind"></WeatherCard>
        </div>
        <p v-if="humidity > 0 && humidity < 101" class="error"></p>
        <p v-if="humidity <= 0" class="error">Humidity must be greater than 0</p>
        <p v-if="humidity > 100" class="error">Humidity must not be greater than 100</p>

    </div>
    <div class="main_chart borderStyle">
      <div class="chart-header">
        <button class="toggle-btn" @click="showTable = !showTable">
          {{ showTable ? 'Show Chart' : 'Show Table' }}
        </button>
        <button class="theme-btn" @click="toggleTheme"
          :title="theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'"
          :aria-label="theme === 'dark' ? 'Switch to light theme' : 'Switch to dark theme'">
          <!-- Material Design "light_mode" (sun) shown in dark theme -->
          <svg v-if="theme === 'dark'" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0 8c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0s.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41s1.03.39 1.41 0l1.06-1.06z" />
          </svg>
          <!-- Material Design "bedtime" (crescent moon) shown in light theme -->
          <svg v-else class="moon-icon" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9.5 2c-1.82 0-3.53.5-5 1.35 2.99 1.73 5 4.95 5 8.65s-2.01 6.92-5 8.65C5.97 21.5 7.68 22 9.5 22c5.52 0 10-4.48 10-10S15.02 2 9.5 2z" />
          </svg>
        </button>
      </div>
      <div class="chart-body">
        <VueApexCharts v-if="!showTable" width="100%" height="100%" type="line" :options="chart_options" :series="series"></VueApexCharts>
        <div v-else class="table-wrapper">
          <vue3-datatable :key="tableRows.length" :rows="tableRows" :columns="tableColumns" :sortable="false" :pagination="false" skin="bh-table-striped bh-table-hover bh-table-bordered"></vue3-datatable>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import axios from "axios";
import config from "./myconfig";
import Notiflix from 'notiflix';
import WeatherCard from "./components/WeatherCard";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import "@bhplugin/vue3-datatable/dist/style.css";

function debounceLeading(fn, delay = 300) {
  let timeoutId = null
  return function (...args) {
    if (!timeoutId) {
      fn.apply(this, args)
    }
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      timeoutId = null
    }, delay)
  }
}

export default {
  name: "App",
  components: {
    VueApexCharts,
    WeatherCard,
    Vue3Datatable
  },
  data() {
    return {
      theme: localStorage.getItem("theme") || "light",
      loading: null,
      loaded: false,
      showWeather: true,
      showTable: localStorage.getItem("showTable") === "true",
      absolute_humidity: 0,
      dew_point: 0,
      temperature: 20,
      site_temperature: 0,
      humidity: 50,
      chart_options: {
        chart: {
          id: "vuechart-example",
        },
        stroke: {
          curve: "straight",
        },
        yaxis: {
          title: {
            text: 'Relative humidity (%)',
          },
          labels: {
            formatter: function (val) {
              return val.toFixed(1);     // converts a number to a string, rounded to a specified number of decimals
            }
          },
        },
        xaxis: {
          title: {
            text: 'Temperature (°C)',
          },
          labels: {
            formatter: function (val) {
              return val.toFixed(0);     // converts a number to a string, rounded to a specified number of decimals
            }
          },
        },
      },
      series: [
        {
          name: "humidity %",
          data: [],
        },
      ],
    };
  },
  watch: {
    showWeather(newVal) {
      if (newVal && !this.loading) {
        console.log("showWeather changed to true, fetching data...");
        this.fetchData();
      } 
    },
    theme(newTheme) {
      localStorage.setItem("theme", newTheme);
    },
    showTable(newVal) {
      localStorage.setItem("showTable", newVal);
    }
  },
  async created() {
    await this.fetchData();
  },
  computed: {
    tableColumns() {
      return [
        { field: "temperature", title: "Temperature (°C)", type: "number", isUnique: true },
        { field: "humidity", title: "Relative Humidity (%)", type: "number" },
      ];
    },
    tableRows() {
      return (this.series[0]?.data || []).map(([temperature, humidity]) => ({
        temperature,
        humidity: Math.round(humidity * 10) / 10,
      }));
    },
  },
  methods: {
    toggleTheme() {
      this.theme = this.theme === "dark" ? "light" : "dark";
    },
    async fetchData() {
      if (this.loading === true || this.showWeather === false) {
        console.log("Already loading data or showWeather is false, skipping fetch.");
        return;
      }
      try {
        this.loading = true;
        const response = await axios.get('https://server1.manduch.com/meteo');
        this.posts = response.data;
        console.log("Loaded response data:", response.data);
        this.temperature = Math.round(this.posts.temp_celsius);
        this.site_temperature = this.temperature;
        this.humidity = Math.round(this.posts.humidity_rh);
        this.site_humidity = this.humidity;
        this.wind = Math.round(this.posts.wind_speed_ms);
        this.site_wind = this.wind;

        Notiflix.Notify.success('Loaded Warsaw weather data', { position: "center-top" });
      } catch (error) {
        console.error("Failed to load posts:", error);
        Notiflix.Notify.warning('Error loading Warsaw weather data', { position: "center-top" });
      } finally {
        this.loading = false;
      }
      this.updateChartandDewPoint();
      if (this.showWeather) {
        this.fetchTimeout = setTimeout(this.fetchData, config.AUTO_REFRESH_INTERVAL_SEC * 1000);
      }
    },

    reset_temp_to_site: debounceLeading(function() {
      this.temperature = this.site_temperature;
      this.humidity = this.site_humidity;
      this.updateChartandDewPoint();
      Notiflix.Notify.success('Using Warsaw temperature data', {position: "center-top"});
    }, 1000),
    updateChartandDewPoint() {
      this.dew_point = this.dewPoint(this.humidity, this.temperature);
      this.absolute_humidity = this.absoluteHumidity(this.humidity, this.temperature)
      if (this.humidity <= 0 || this.humidity > 100) {
        this.dew_point = 0
        this.absolute_humidity = 0
        this.series = [
          {
            name: "Rh %",
            data: []
          },
        ];
        return
      }
      let data_points = []
      for (let i = config.MIN_TEMP; i <= config.MAX_TEMP; i++) {
        let rel_humidity = this.relativeHumidity(i, this.dew_point)
        if (rel_humidity >= 100) {
          rel_humidity = 100
        }
        data_points.push([i, rel_humidity])
      }

      data_points = this.clean_data_points(data_points)
      this.series = [
        {
          name: "Rh %",
          data: data_points
        },
      ];
    },
    /**
     * Cleans the data points by removing any points that have a relative humidity of 100 or more,
     * just first point with 100% is kept.
     * @param {Array} data_points - The array of data points to clean
     * @return {Array} - The cleaned array of data points
     */
    clean_data_points(data_points) {  
      let first_point_with_100_Rh = 0; 
      for (let i = data_points.length-1; i>=0; i--) {
        if (data_points[i][1] >= 100.0){
          first_point_with_100_Rh = i;
          break;
        }
        }
      return data_points.slice(first_point_with_100_Rh, first_point_with_100_Rh.length)
    },
    /**
     * Calculates a dew point in Celsius degrees using Magnus coefficients
     * like in https://www.omnicalculator.com/physics/dew-point
     * @param {number} rel_humidity humidity in %
     * @param {number} temperature temperature in degrees of Celsius
     * @return {number} dew point in degrees of Celsius
     */
    dewPoint(rel_humidity, temperature) {
      let a = 17.27;
      let b = 237.3;
      let alpha =
        Math.log(rel_humidity / 100) +
        (a * temperature) / (b + temperature);
      return Math.round(((b * alpha) / (a - alpha)) * 10) / 10;
    },

    /**
     * Calculates relative humidity from dew point and temperature according
     * formula: https://www.calctool.org/atmospheric-thermodynamics/absolute-humidity
     * @param {number} dew_point dew point in degrees of Celsius
     * @param {number} temp temperature in degrees of Celsius
     * @return {number} relative air humidity in %
     */
    relativeHumidity(temp, dew_point) {
      let first_part = Math.exp((17.625 * dew_point) / (243.04 + dew_point));
      let second_part = Math.exp((17.625 * temp) / (243.04 + temp));
      let rel_humidity = 100 * first_part / second_part;
      return rel_humidity
    },
    /**
     * Calculates absolute air humidity from relative humidity in given temperature
     * More on formula: https://www.omnicalculator.com/physics/absolute-humidity
     * @param {number} Rh_percent relative humidity in percents, i.e. value 0 - 100
     * @param {number} temp_celsius temperature in Celsius degree
     * @return {number} absolute humidity in g/m3 - how many kg of water is in m3 of air
     */
    absoluteHumidity(Rh_percent, temp_celsius) {
      let temp_kelvin = temp_celsius + 273.15;
      let abs_humidity_kg_m3 = (Rh_percent * this.saturation_water_vapour_pressure(temp_celsius)) / (461.52 * temp_kelvin * 100);
      let abs_humidity_g_m3 = abs_humidity_kg_m3 * 1000
      return Math.round(abs_humidity_g_m3 * 10) / 10;
    },
    /**
     * Calculates water vapour pressure for given temperature using Teten's equation.
     * More on formula: https://en.wikipedia.org/wiki/Vapour_pressure_of_water
     * @param  {number}  temperature in Celsius degrees
     * @return {number}  water vapour pressure in Pascals
     */
    saturation_water_vapour_pressure(temp_celsius) {
      let result_Pa = 0
      result_Pa = 610.78 * Math.exp((17.27 * temp_celsius) / (temp_celsius + 237.3));
      return result_Pa;
    }
  },
};
</script>

<style>
label,
p {
  font-weight: bold;
  display: inline-flex;
  margin-right: 1.25rem;
  margin-top: 0.3125rem;
  margin-bottom: 0.3125rem;
  color: #1e3a5f;
}

input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 0.375rem 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.428;
  color: #1e3a5f;
  border: 0.0625rem solid #cfe2f3;
  border-radius: 0.375rem;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}

input:focus {
  border-color: #008ffb;
  /* box-shadow: 0 0 0 0.1875rem rgba(0, 143, 251, 0.18); */
}

input[type="number"]:focus {
  box-shadow: 0 0 0 0.3rem rgba(0, 143, 251, 0.18);
}


input[readonly] {
  background-color: #f4f9fe;
  color: #005c9e;
}

input[type="checkbox"] {
  display: inline-block;
  width: auto;
  margin-top: 0.25rem;
  cursor: pointer;
}

.center {
  margin: auto;
}

.main_chart {
  float: left;
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 1rem;
  /* grow to fill remaining space, and use basis 0 so the panel width does not
     depend on its content (chart vs. table) */
  flex: 1 1 0;
  min-width: 0;
  padding: 0.625rem;
  height: 100%;
}

.chart-body {
  height: calc(100% - 2.5rem);
}

#main_div {
  margin: auto;
  width: 100%;
}

.app-banner {
  background: linear-gradient(90deg, #005c9e, #008ffb);
  color: #ffffff;
  padding: 1rem 1.5rem;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 92, 158, 0.25);
}

.app-banner h1 {
  margin: 0;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

#form_and_chart {
  display: flex;
  flex-wrap: nowrap;
  height: calc(95vh - 5rem);
  /* height: 80vh; */
}

#form_div {
  padding: 1.25rem;
  margin-top: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  /* fixed width so the form does not steal space from the chart/table panel */
  flex: 0 0 16rem;
}

.temperature {
  margin-top: 0.625rem;
}

.humidity {
  margin-top: 0.625rem;
}

.error {
  margin-top: 0.625rem;
  color: #dc2626;
}

.chart-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.5rem;
  padding: 0.1rem 0.5rem 0.2rem;
}

.theme-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  font-size: 1rem;
  line-height: 1;
  background-color: #e6f3fd;
  border: 0.0625rem solid #cfe2f3;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}

.theme-btn:hover {
  background-color: #cfe2f3;
}

.theme-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  fill: #005c9e;
}

.theme-btn .moon-icon {
  transform: scaleX(-1);
}

.toggle-btn {
  padding: 0.375rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: #ffffff;
  background-color: #008ffb;
  border: none;
  border-radius: 0.375rem;
  cursor: pointer;
  transition: background-color 0.15s;  
}

.toggle-btn:hover {
  background-color: #0072c9;
}

.table-wrapper {
  padding: 0.75rem;
  height: calc(100% - 3rem);
  overflow: auto;
}

/* Stretch the datatable to fill its container, matching the chart's full width.
   By default the <table> only grows to fit its (narrow) content. */
.table-wrapper .bh-table-responsive table {
  width: 100%;
}

/* Make zebra striping more pronounced than the package default (#e0e6ed26).
   Must match the package's selector specificity and add .table-wrapper to win. */
.table-wrapper .bh-table-responsive table.bh-table-striped tbody tr:nth-child(odd) {
  background-color: #e6f3fd;
}

.table-wrapper .bh-table-responsive table.bh-table-hover tbody tr:hover,
.table-wrapper .bh-table-responsive table.bh-table-hover tbody tr:hover td {
  background-color: #cfe8fb;
  color: #003d68;
}

.borderStyle {
  border-radius: 0.75rem;
  border: 0.0625rem solid #d6e8f7;
  background-color: #ffffff;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 92, 158, 0.08);
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #1e3a5f;
  background-color: #eef6fc;
  margin-top: 0;
  height: 100%;
  width: 100%;
}

/* On narrow screens (phones/small tablets) stack the form above the chart
   instead of forcing a horizontally scrollable desktop-width layout */
@media (max-width: 53.75rem) {
  #form_and_chart {
    flex-direction: column;
    height: auto;
  }

  #form_div {
    /* in a column layout the 16rem flex-basis would become height, not width */
    flex: 0 0 auto;
  }

  .main_chart {
    /* height: 100% has no effect once the parent's height is auto */
    height: 60vh;
    flex: 0 0 auto;
    margin-bottom: 1rem;
  }
}

body,
html {
  height: 100%;
  margin: 0;
  padding: 0;
}

/* ---------- Dark theme ---------- */
#main_div.dark {
  background-color: #0f1a2b;
  min-height: 100%;
  /* render native form controls (number spinners, checkboxes) in dark style */
  color-scheme: dark;
}

#main_div.dark .app-banner {
  background: linear-gradient(90deg, #0a1526, #16233a);
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.5);
}

#main_div.dark .borderStyle {
  background-color: #16233a;
  border-color: #24344f;
  box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.4);
}

#main_div.dark label,
#main_div.dark p {
  color: #cfe2f3;
}

#main_div.dark input {
  color: #e6f3fd;
  background-color: #1e2d47;
  border-color: #24344f;
}

#main_div.dark input[readonly] {
  background-color: #182742;
  color: #8ec5f0;
}

#main_div.dark input:focus {
  border-color: #008ffb;
}

#main_div.dark .theme-btn {
  background-color: #1e2d47;
  border-color: #24344f;
}

#main_div.dark .theme-btn:hover {
  background-color: #24344f;
}

#main_div.dark .theme-btn svg {
  fill: #ffd873;
}

#main_div.dark .table-wrapper .bh-table-responsive table {
  color: #e6ecf5;
}

#main_div.dark .table-wrapper .bh-table-responsive table th {
  color: #ffffff;
  background-color: #24344f;
}

#main_div.dark .table-wrapper .bh-table-responsive table.bh-table-striped tbody tr:nth-child(odd) {
  background-color: #1e2d47;
}

#main_div.dark .table-wrapper .bh-table-responsive table,
#main_div.dark .table-wrapper .bh-table-responsive table th,
#main_div.dark .table-wrapper .bh-table-responsive table td {
  border-color: #3a4a63;
}

#main_div.dark .table-wrapper .bh-table-responsive table.bh-table-hover tbody tr:hover,
#main_div.dark .table-wrapper .bh-table-responsive table.bh-table-hover tbody tr:hover td {
  background-color: #2c3e5c;
  color: #ffffff;
}

/* Lighten ApexCharts text (SVG labels/titles) in dark theme */
#main_div.dark .apexcharts-text,
#main_div.dark .apexcharts-xaxis-label,
#main_div.dark .apexcharts-yaxis-label,
#main_div.dark .apexcharts-xaxis-title-text,
#main_div.dark .apexcharts-yaxis-title-text,
#main_div.dark .apexcharts-title-text {
  fill: #cfe2f3 !important;
}

#main_div.dark .apexcharts-legend-text {
  color: #cfe2f3 !important;
}
</style>